// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './Login';
import OrderList from './OrderList';
import PrivateRoute from './PrivateRoute';

const App: React.FC = () => {
  return (
    <Router>
      <div>
        <h1>Firebase Auth ログインと注文一覧</h1>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route element={<PrivateRoute />}>
            <Route path="/orders" element={<OrderList />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
};

export default App;
